import { UseQueryResult } from '@tanstack/react-query';

import { API_QUERY_KEYS, getRespondedYearToDateReport, useBaseReport } from '../../../api';
import { ReportResponse } from '../../../types';

export const useRespondedYearToDateReport = (): UseQueryResult<ReportResponse> =>
  useBaseReport(API_QUERY_KEYS.getRespondedYearToDateReport, getRespondedYearToDateReport);
